<template>
  <div class="delete-archive-dialog-box">
    <el-dialog
      :title="$t('wr-dashboard.delete-archive-dialog-box.title')"
      @close="onClose"
      visible
    >
      <div
        class="el-text el-text--body-24 mx-24 my-16"
        v-if="!isArchiveLocked">
        {{ $t('wr-dashboard.delete-archive.message') }}
      </div>

      <el-alert
        type="warning"
        :description="$t('wr-dashboard.delete-archive.locked-error-message')"
        show-icon
        hide-close
        v-if="isArchiveLocked"
      />

      <el-alert
        type="warning"
        :description="$t('wr-dashboard.delete-archive.deletion-warning-message')"
        show-icon
        hide-close
        v-else
      />

      <template slot="footer">
        <el-button
          @click="onClose"
          native-type="button"
          type="secondary"
        >
          {{ $t('wr-dashboard.form.button.cancel') }}
        </el-button>
        <el-button
          native-type="button"
          @click="onDelete"
          type="danger"
          :loading="isInProgress"
          :disabled="isInProgress"
        >
          {{ $t('wr-dashboard.form.button.delete') }}
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import {
  DELETE_ARCHIVE,
  RESET_ARCHIVE_DELETION_STATUS
} from '../store/action-types';

import {
  PENDING_STATUS,
  COMPLETED_STATUS,
  LOCKED_STATUS
} from '../store/action-status';

const { mapGetters, mapActions } = createNamespacedHelpers('wr-dashboard');

export default {
  name: 'DeleteArchiveDialogBox',
  props: {
    archiveId: {
      type: String,
      default: '',
      required: true
    },
    boxGroup: {
      type: String,
      default: 'ARCHIVES',
      required: false
    }
  },
  data() {
    return {
      isArchiveLocked: false
    };
  },
  computed: {
    ...mapGetters([
      'getArchiveDeletionStatus'
    ]),
    isInProgress() {
      return this.getArchiveDeletionStatus === PENDING_STATUS;
    }
  },
  watch: {
    getArchiveDeletionStatus(status) {
      if (status === COMPLETED_STATUS) {
        this.onClose();
      } else if (status === PENDING_STATUS) {
        this.isArchiveLocked = false;
      } else if (status === LOCKED_STATUS) {
        this.isArchiveLocked = true;
      }
    }
  },
  methods: {
    ...mapActions({
      deleteArchive: DELETE_ARCHIVE,
      resetArchiveDeletionStatus: RESET_ARCHIVE_DELETION_STATUS
    }),
    onDelete() {
      this.deleteArchive(this.archiveId);
    },
    onClose() {
      this.$emit('handleClose');
    }
  },
  mounted() {
    this.isArchiveLocked = false;
    this.resetArchiveDeletionStatus();
  }
};
</script>

<style lang="scss" scoped>

</style>
